/* 筛选按钮<el-popover
  placement="bottom"
  width="300"
  v-model="popoverVisible">
  <el-checkbox-group v-model="propList">
    <el-checkbox :label="item" v-for="(item, index) in allPropList" :key="index" style="width: 120px">{{item.label}}</el-checkbox>
  </el-checkbox-group>
  <el-button slot="reference" size="small" style="float: right;">筛选</el-button>
</el-popover> */

/* 循环列<el-table-column
  :label="item.label"
  :prop="item.prop"
  :min-width="item.width"
  :sortable="item.sortable ? 'custom' : false"
  show-overflow-tooltip
  v-for="item in sortedPropList" :key="item.prop"
>
  <template slot-scope="scope">
    <template>
      {{scope.row[item.prop]}}
    </template>
  </template>
</el-table-column> */

// 导出
// const loading = this.$loading({
//   lock: true,
//   text: 'Loading',
//   spinner: 'el-icon-loading',
//   background: 'rgba(0, 0, 0, 0.7)'
// });
// let params = {
//   taskDTO: {
//     appCode: "ec-pc-api",
//     // 数据过滤
//     paramMap: {
//       exportTag: true,
//       ...this.searchForm.filterData
//     },
//     reportName: "skuExport"
//   },
//   // 配置导出列
//   columnDTOs: [
//     // {
//     //   columnName: '包件编码',
//     //   parentColumnName: null,
//     //   fieldName: 'packCode',
//     //   fieldType: 'string',
//     //   columnFormat: null
//     // }
//   ]
// };
// let labels = this.sortedPropList.map(v=>v.label);
// let props = this.sortedPropList.map(v=>v.prop);
// props.forEach((prop, index) => {
//   params.columnDTOs.push({
//     columnName: labels[index],
//     parentColumnName: null,
//     fieldName: prop,
//     fieldType: 'string',
//     columnFormat: null
//   })
// })
// // 不导出图片列
// params.columnDTOs = params.columnDTOs.filter(v=>v.columnName !== '图片');
// this.$q.common.customExportExcel({data: params}).then((res) => {
//   console.log(res)
//   loading.close();
//   this.$message({
//     type: "success",
//     message: "导出成功,请在导出列表中查看",
//   });
// });


//动态列自定义表格
export default {
  data() {
    return {
      columnData: [],
      tableDataSet: [],
      reportName: 'deliveryShortagePack',
      tableVisible: false,
      pagingColumnData: [],
      isShowTure: [],
      userColumnsData: [],
      tableReload: true
    }
  },
  mounted() {
    this.columns()
  },
  methods: {
    columns(type) {
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then(res => {
        this.isShowTure = res.data.userColumns.length ? res.data.userColumns.filter(v=>v.isShow).map(v=>v.displayName) : []
        this.userColumnsData = res.data.userColumns.length ? res.data.userColumns : []
        this.customColumn()
      });
    },
    closeAddForm() {
      this.tableVisible = false;
      this.columns()
    },
    confirm() {
      let data = []
      this.tableDataSet.forEach(v => {
        let freezeFlag = v.freezeLeft || v.freezeRight ? true : false
        data.push({
          displayName: v.displayName,
          columnName: v.columnName,
          displayWidth: parseInt(v.displayWidth),
          reportName: this.reportName,
          freezeFlag: freezeFlag,
          sortable: v.sortable,
          freezeType: freezeFlag && v.freezeLeft ? 'left' : freezeFlag && v.freezeRight ? 'right' : '',
          isShow: v.isShow
        })
      })
      this.$q.common.mergeColumns({ data: data }).then(res => {
        if (res.success) {
          this.$message.success('自定义配置成功')
          this.tableReload = false
          this.$nextTick(_ => {
            this.tableReload = true;
          });
          this.columns()
        } else {
          this.$message.error('自定义配置失败')
        }
        this.closeAddForm()
      });
    },
     customColumn(data) {
      this.columnData = []
      var data = [];
      var tableDataSet = []
      var columnData = this.userColumnsData.map(v=>v.displayName) 
      this.pagingColumnData.forEach((v) => {
        let index = columnData.indexOf(v.titleName)
        if(this.userColumnsData.length) { //用户配置返回
          if(columnData.indexOf(v.titleName) != -1) { //包含用户之前配置的列
            tableDataSet.push({
              displayName: this.userColumnsData[index].displayName,
              displayWidth: this.userColumnsData[index].displayWidthNum,
              freezeLeft: this.userColumnsData[index].freezeType == 'left' ? true : false,
              freezeRight: this.userColumnsData[index].freezeType == 'right' ? true : false,
              isShow: this.userColumnsData[index].isShow,
              columnName: this.userColumnsData[index].columnName,
              sortable: v.sortable
            })
            if(this.isShowTure.indexOf(v.titleName) == -1) {
              data.push({
                label: this.userColumnsData[index].displayName,
                prop: this.userColumnsData[index].columnName,
                width: this.userColumnsData[index].displayWidth,
                sortable: this.userColumnsData[index].sortable == "1" ? 'custom' : false,
                span: false,
                fixed: this.userColumnsData[index].freezeType,
              });
            }
          }else { //不包含使用分页返回的列
            tableDataSet.push({
              displayName: v.titleName,
              displayWidth: '100',
              freezeLeft: v.freezeType == 'left' ? true : false,
              freezeRight: v.freezeType == 'right' ? true : false,
              isShow: v.isShow,
              columnName: v.propertyName,
              sortable: v.sortable
            })
            if(this.isShowTure.indexOf(v.titleName) == -1) {
              data.push({
                label: v.titleName,
                prop: v.propertyName,
                width: "100px",
                sortable: v.sortable == '1' ? "custom" : false,
                span: false,
                fixed: v.fixed == "1" ? "left" : false,
              });
            }
          }
        }else {//用户为配置使用分页默认配置
          tableDataSet.push({
            displayName: v.titleName,
            displayWidth: '100',
            freezeLeft: v.freezeType == 'left' ? true : false,
            freezeRight: v.freezeType == 'right' ? true : false,
            isShow: v.isShow,
            columnName: v.propertyName,
            sortable: v.sortable
          })
          data.push({
            label: v.titleName,
            prop: v.propertyName,
            width: "150px",
            sortable: v.sortable == '1' ? "custom" : false,
            span: false,
            fixed: v.fixed == "1" ? "left" : false,
           });
          }
      });
      this.columnData = data
      this.tableDataSet = tableDataSet
    }
  }
}